import { CheckboxWithDisplay, CheckboxWithDisplayProps, Color } from '@blend/consumer-components';
import * as React from 'react';

import * as deploymentConfig from 'login-utils/deploymentConfig';
import * as inputUtils from '../inputUtils';
import InputContainer from '../InputContainer/InputContainer';

const actionColor = deploymentConfig.getOrganizationColors().action;

namespace Checkbox {
  export interface Props extends InputProps {
    displayParts: CheckboxWithDisplayProps['displayParts'];
    identifier: string;
    color?: Color;
  }
}

class Checkbox extends React.PureComponent<Checkbox.Props> {
  render() {
    const {
      input,
      meta,
      displayParts,
      color /* istanbul ignore next: (UI-5482) */ = actionColor,
      identifier,
      ...htmlProps
    } = this.props;
    const error = meta.touched && meta.error;
    const { name } = input;
    const ariaProps = inputUtils.getAriaProps(name, !!error);

    return (
      <InputContainer name={name} error={error} identifier={identifier}>
        <CheckboxWithDisplay
          {...input}
          {...htmlProps}
          {...ariaProps}
          checked={!!input.value}
          id={identifier}
          color={color}
          displayParts={displayParts}
          data-exclude-fullstory="always"
        />
      </InputContainer>
    );
  }
}

export const CheckboxInputConfig = {
  component: Checkbox,
};

export default Checkbox;
